import { ArrowUpRight } from "lucide-react";
import { trackPixel } from "@/lib/fbpixel";

const HERO_IMG = "/assets/img/hero-bg.webp";

export default function Hero() {
  return (
    <section id="hero" data-testid="hero-section" className="relative min-h-screen flex flex-col overflow-hidden">
      {/* Full background image */}
      <div className="absolute inset-0">
        <img src={HERO_IMG} srcSet="/assets/img/hero-bg-mobile.webp 828w, /assets/img/hero-bg.webp 1410w" sizes="100vw" alt="Campos de padel do Just Padel Center Barcelos" className="w-full h-full object-cover object-[80%_center] lg:object-center" loading="eager" fetchPriority="high" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0a0f1a]/90 via-[#0a0f1a]/50 to-transparent" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0a0f1a] via-transparent to-[#0a0f1a]/30" />
      </div>

      {/* Content - on mobile: text top, buttons bottom */}
      <div className="relative z-10 max-w-[1440px] mx-auto px-6 lg:px-10 w-full pt-24 flex-1 flex flex-col justify-between lg:justify-center">
        {/* Text block - top on mobile, centered on desktop */}
        <div className="max-w-2xl">
          {/* Tag */}
          <div className="mb-6">
            <span className="font-body uppercase text-xs font-medium tracking-[0.2em] !text-[rgba(255,255,255,0.6)]">
              The home of <span className="text-jp-lime">Padel</span>
            </span>
          </div>

          {/* Headline */}
          <h1 className="font-display text-5xl sm:text-6xl lg:text-7xl xl:text-[80px] text-white leading-[1.1] mb-6 font-medium">
            Aqui jogas dentro e
            <span className="italic !text-[rgba(238,209,27,0.8)]"> fora de campo.</span>
          </h1>

          {/* Subtitle */}
          <p className="font-body max-w-md !text-base mb-10 !text-[rgba(255,255,255,0.8)]">Espaço premium, um novo nível de energia, zero stress. 

          </p>
        </div>

        {/* Buttons - bottom on mobile, inline on desktop */}
        <div className="max-w-2xl pb-10 lg:pb-0 lg:-mt-4">
          <div className="flex flex-wrap gap-3">
            <a
              href="https://smashpro.pt/pt/justpadel-barcelos"
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => trackPixel("InitiateCheckout")}
              className="bg-jp-lime text-black font-body font-semibold text-sm px-6 py-3.5 rounded-full flex items-center gap-2 hover:bg-jp-lime-dark transition-all group"
              data-testid="hero-booking-btn">
              Reservar campo
              <span className="w-6 h-6 bg-black/10 rounded-full flex items-center justify-center group-hover:bg-black/20 transition-colors">
                <ArrowUpRight size={13} />
              </span>
            </a>
          </div>
        </div>
      </div>
    </section>);

}